<template>
  <nav
    class="btn-bg-swap bg-purchase-flow-top-nav-gradient rounded-b-3xl"
    :class="
      UIStore.is_loading || UIStore.is_change_investment_loading || isThankYouRoute
        ? ''
        : 'shadow-navbar-invest'
    "
  >
    <div
      class="h-[60px] lg:h-[4.5rem] flex items-center pl-3 pr-6 overflow-hidden max-w-[1440px] mx-auto"
    >
      <!-- Left: Logo -->
      <div class="flex-shrink-0 hidden lg:flex">
        <!-- <RouterLink to="/"> -->
        <IconPHXLogo
          @click="
            isChangeInvestementFlow
              ? router.push('/dashboard')
              : (purchaseFlowStore.is_show_disclaimer_modal = true)
          "
          class="h-[38px] cursor-pointer"
          :class="UIStore.is_dark_mode ? 'text-white' : 'text-black'"
        />
        <!-- </RouterLink> -->
      </div>
      <!-- Center Content -->
      <div class="flex-1 flex lg:justify-center lg:px-[4.5rem]">
        <div class="flex items-center gap-6 w-full">
          <img
            v-if="!isThankYouRoute"
            @click="
              isChangeInvestementFlow
                ? router.push('/dashboard')
                : (purchaseFlowStore.is_show_disclaimer_modal = true)
            "
            :src="purchaseNavMedallion"
            alt=""
            class="lg:hidden h-10 flex-shrink-0 -mr-4"
          />

          <img
            v-if="!isThankYouRoute"
            :src="purchaseNavMedallion"
            alt=""
            class="hidden lg:block h-32 mr-4 flex-shrink-0"
          />
          <div class="flex-1 min-w-0">
            <div class="flex justify-between items-center">
              <h3
                v-if="isThankYouRoute"
                class="font-inter lg:font-league text-sm lg:text-xl text-strongest mb-1.5 lg:mb-2 font-semibold whitespace-nowrap"
              >
                Investment {{ isS1QuietPeriod ? "submitted" : "completed" }}
              </h3>
              <h3
                v-else
                class="text-sm lg:text-xl text-strongest mb-1.5 lg:mb-2 font-semibold whitespace-nowrap"
              >
                <template v-if="isChangeInvestementFlow">
                  <span class="font-inter"> Change Investment</span>
                </template>
                <template v-else>
                  <!-- <span class="lg:hidden font-inter lg:font-league"
                    >Completing {{ offeringTypeLabel }}</span
                  > -->
                  <span class="font-inter lg:font-league">Completing your investment</span>
                </template>
              </h3>
              <p
                v-if="!isThankYouRoute"
                class="font-inter text-xs font-semibold text-strong lg:hidden"
              >
                {{
                  isChangeInvestementFlow
                    ? `${changeInvestmentStore.current_step} / ${changeInvestmentStore.change_investment_steps?.length || 3}`
                    : `${purchaseFlowStore.current_step} / ${purchaseFlowStore.investment_steps?.length || 10}`
                }}
              </p>
            </div>

            <Stepper
              :numSteps="
                isChangeInvestementFlow
                  ? changeInvestmentStore.change_investment_steps?.length || 10
                  : purchaseFlowStore.investment_steps?.length || 10
              "
              :stepToWatch="
                isChangeInvestementFlow
                  ? changeInvestmentStore.current_step || 10
                  : purchaseFlowStore.current_step || 10
              "
              @set-active-step="
                isChangeInvestementFlow
                  ? (changeInvestmentStore.current_step = $event)
                  : (purchaseFlowStore.current_step = $event)
              "
              :disabled="isThankYouRoute"
            />
          </div>
        </div>
      </div>

      <!-- Right: CTA -->
      <div class="flex flex-shrink-0 ml-4 mt-2 lg:m-0 gap-2 items-center">
        <Button
          size="sm"
          variant="paper-primary"
          @click="UIStore.toggleDarkMode"
          class="hidden lg:inline-flex"
        >
          <template #icon>
            <Icon :name="UIStore.is_dark_mode ? 'Sun' : 'Moon'" class="h-4 w-4" :stroke-width="2" />
          </template>
        </Button>
        <Button
          @click="handleCallClick"
          size="sm"
          variant="paper-primary"
          class="hidden lg:inline-flex"
        >
          <template #label>
            <span class="font-inter">Call 855-732-6395</span>
          </template>
          <template #icon>
            <Icon name="Phone" class="h-4 w-4" :stroke-width="1.5" />
          </template>
        </Button>
        <Button @click="handleCallClick" size="xs" variant="paper-primary" class="lg:hidden">
          <template #label>
            <span class="font-inter">Call Us</span>
          </template>
        </Button>
      </div>
    </div>
  </nav>
</template>

<script setup>
import { computed, onUnmounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { Button, Icon, Stepper } from "@/components";
import { IconPHXLogo } from "@/components/icons";
import {
  useUIStore,
  usePurchaseFlowStore,
  useChangeInvestmentStore,
  useDataStore,
  useCrudStore,
} from "@/stores";

import purchaseNavMedallion from "@/assets/images/investment_silver_circle.png";

const UIStore = useUIStore();
const purchaseFlowStore = usePurchaseFlowStore();
const dataStore = useDataStore();
const changeInvestmentStore = useChangeInvestmentStore();
const crudStore = useCrudStore();

const route = useRoute();
const router = useRouter();

onUnmounted(() => {
  purchaseFlowStore.is_show_disclaimer_modal = false;
});

const isS1QuietPeriod = computed(() => {
  return (
    purchaseFlowStore.completed_investment?.offering_type === "S1" &&
    dataStore.s1_offerings_in_quiet_period
  );
});
const isChangeInvestementFlow = computed(() => route.path.startsWith("/change-investment"));
const isThankYouRoute = computed(() => route.path === "/thank-you");
const offeringTypeLabel = computed(() => {
  const type = purchaseFlowStore?.selected_offering?.type;
  if (type === "S1") return "Registered Offering";
  if (type === "Reg D") return "Regulation D";
  return type;
});

function handleCallClick() {
  let log = {
    step: "Call Us",
    substep: "tel:855-732-6395",
    status: "Navigated",
    message: "",
    url: "",
    validation_details: null,
  };

  log = dataStore.setDefaultFields(log, "investoractivity");
  crudStore.insert("investoractivity", [log]);
  window.location.href = "tel:855-732-6395";
}
</script>
